module.exports = __webpack_public_path__ + "images/c9232f4d33fef153afe59dac1a457d74train.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/train.png
// module id = PVqT
// module chunks = 0